(function () {
  'use strict';
  if (window.dhLaunchCountdownLoaded) return;
  window.dhLaunchCountdownLoaded = true;
  function bind(element) {
    if (element.dataset.countdownBound) return;
    var target = Date.parse(element.dataset.launchAt);
    if (!Number.isFinite(target)) return;
    element.dataset.countdownBound = 'true';
    var label = element.querySelector('.dh-launch-countdown__label');
    var units = element.querySelector('.dh-launch-countdown__units');
    var fields = {};
    ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit) {
      fields[unit] = element.querySelector('[data-countdown-unit="' + unit + '"]');
    });
    var timer;
    function update() {
      if (!element.isConnected) { window.clearInterval(timer); return; }
      var remaining = Math.max(0, Math.ceil((target - Date.now()) / 1000));
      var values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining % 86400 / 3600),
        minutes: Math.floor(remaining % 3600 / 60),
        seconds: remaining % 60
      };
      Object.keys(values).forEach(function (unit) {
        var value = String(values[unit]).padStart(2, '0');
        if (fields[unit].textContent !== value) fields[unit].textContent = value;
      });
      if (!remaining) {
        label.textContent = element.dataset.launchArrived;
        units.hidden = true;
        window.clearInterval(timer);
      }
      element.hidden = false;
      return remaining;
    }
    if (update() > 0) timer = window.setInterval(function () { if (!document.hidden) update(); }, 1000);
  }
  function initialize(scope) { scope.querySelectorAll('[data-launch-countdown]').forEach(bind); }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
